// FrustumTester
// Recomputes the camera frustum each tick from projectionMatrix *
// matrixWorldInverse. Tests are AABB-vs-frustum via the standard
// three.js Frustum.intersectsBox.

import { Frustum, Matrix4 } from 'three';

export default class FrustumTester {
  constructor(camera) {
    this.camera = camera;
    this.frustum = new Frustum();
    this._mat = new Matrix4();
  }

  update() {
    this.camera.updateMatrixWorld();
    this._mat.multiplyMatrices(
      this.camera.projectionMatrix,
      this.camera.matrixWorldInverse
    );
    this.frustum.setFromProjectionMatrix(this._mat);
  }

  intersectsBox(box) {
    return this.frustum.intersectsBox(box);
  }
}